import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-b border-[#e3eaf4] px-6 py-5" }
const _hoisted_2 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_3 = { class: "space-y-2 md:col-span-2" }
const _hoisted_4 = { class: "space-y-2 md:col-span-2" }
const _hoisted_5 = { class: "space-y-2 md:col-span-2" }
const _hoisted_6 = { class: "space-y-2" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = { class: "space-y-2" }
const _hoisted_16 = { class: "space-y-2 md:col-span-2" }
const _hoisted_17 = { class: "space-y-2 md:col-span-2" }
const _hoisted_18 = { class: "space-y-2 md:col-span-2" }
const _hoisted_19 = { class: "space-y-2 md:col-span-2" }
const _hoisted_20 = { class: "space-y-2" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = { class: "space-y-2" }
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "space-y-2" }
const _hoisted_26 = { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-2" }
const _hoisted_27 = {
  key: 0,
  class: "rounded-[1rem] border border-[#f5c2c7] bg-[#fff5f5] px-4 py-3 text-sm text-[#b42318]"
}

import { computed, reactive, watch } from "vue";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { ReportRecord } from "@/types/reports";
import { reportSectionConfig } from "./reportSectionConfig";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportQuickEditDialog',
  props: {
    open: { type: Boolean },
    report: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = computed({
  get: () => props.open,
  set: (value: boolean) => emit("update:open", value),
});

const form = reactive({
  title: "",
  prepared_by: "",
  executive_snapshot_note: "",
  overall_recommendation_summary: "",
  sections: {
    socialMediaPerformance: { enabled: false, insight: "", recommendation: "" },
    aiChatbotManagement: { enabled: false, insight: "", recommendation: "" },
    aiPodcastProgress: { enabled: false, insight: "", recommendation: "" },
    blogManagement: { enabled: false, insight: "", recommendation: "" },
    seoManagement: { enabled: false, summary: "", insight: "", recommendation: "" },
    adsManagement: { enabled: false, insight: "" },
    generatedLeads: { enabled: false, insight: "", learning: "", business_meaning: "", recommendation: "" },
    promotionalMaterials: { enabled: false, insight: "", recommendation: "" },
    journey: { enabled: false, insight: "", recommendation: "" },
  } as Record<string, { enabled: boolean; summary?: string; insight: string; learning?: string; business_meaning?: string; recommendation?: string }>,
});

function sectionEnabled(key: string): boolean {
  const legacyKeyMap: Record<string, string> = {
    socialMediaPerformance: "social_media",
    aiChatbotManagement: "ai_chatbot",
    aiPodcastProgress: "ai_podcast",
    seoManagement: "seo_ads",
    adsManagement: "ads_management",
    generatedLeads: "generated_leads",
    promotionalMaterials: "promotional_materials",
    journey: "three_month_journey",
  };
  const legacyKey = legacyKeyMap[key];
  return !!(
    props.report?.selected_sections?.includes(key) ||
    (legacyKey && props.report?.selected_sections?.includes(legacyKey))
  );
}

function resetForm() {
  if (!props.report) return;

  const reportData = (props.report.report_data || {}) as Record<string, any>;
  const normalizedSections = (reportData.normalized_report_data?.sections || {}) as Record<string, any>;

  form.title = props.report.title || "";
  form.prepared_by = String(reportData.prepared_by || "Proweaver");
  form.executive_snapshot_note = String(reportData.executive_snapshot_note || reportData.executive_note || "");
  form.overall_recommendation_summary = String(
    reportData.overall_recommendation_summary || reportData.recommendation_summary || ""
  );

  reportSectionConfig.forEach((sec) => {
    const isEnabled = sectionEnabled(sec.key);
    const secData = reportData.sections?.[sec.key] || {};
    const normSec = normalizedSections[sec.key] || {};
    
    let summary = secData.summary || normSec.summary || reportData[`${sec.key}_summary`] || "";
    let insight = secData.insight || normSec.insight || "";
    let learning = secData.learning || normSec.learning || "";
    let businessMeaning = secData.business_meaning || normSec.business_meaning || "";
    let recommendation = secData.recommendation || normSec.recommendation || "";

    if (!reportData.sections && !reportData.normalized_report_data) {
      if (sec.key === "socialMediaPerformance") {
        insight = reportData.social_media_insight || "";
        recommendation = reportData.social_media_recommendation || "";
      } else if (sec.key === "aiChatbotManagement") {
        insight = reportData.ai_chatbot_insight || reportData.chatbot_insight || "";
        recommendation = reportData.ai_chatbot_recommendation || reportData.chatbot_recommendation || "";
      } else if (sec.key === "aiPodcastProgress") {
        insight = reportData.ai_podcast_insight || reportData.podcast_insight || "";
        recommendation = reportData.ai_podcast_recommendation || reportData.podcast_recommendation || "";
      } else if (sec.key === "seoManagement") {
        insight = reportData.seo_ads_insight || reportData.seo_insight || "";
      } else if (sec.key === "promotionalMaterials") {
        insight = reportData.promotional_materials_insight || "";
        recommendation = reportData.promotional_materials_recommendation || "";
      } else if (sec.key === "blogManagement") {
        insight = reportData.blog_insight || "";
        recommendation = reportData.blog_recommendation || "";
      } else if (sec.key === "generatedLeads") {
        insight = reportData.generated_leads_insight || "";
        learning = reportData.generated_leads_learning || "";
        businessMeaning = reportData.generated_leads_business_meaning || "";
        recommendation = reportData.generated_leads_recommendation || reportData.generated_leads_next_action || "";
      } else if (sec.key === "journey") {
        insight = reportData.journey_insight || "";
        recommendation = reportData.journey_recommendation || reportData.journey_next_action || "";
      }
    }

    form.sections[sec.key] = {
      enabled: isEnabled,
      summary: sec.key === "seoManagement" ? summary : undefined,
      insight,
      learning: sec.key === "generatedLeads" ? learning : undefined,
      business_meaning: sec.key === "generatedLeads" ? businessMeaning : undefined,
      recommendation,
    };
  });
}

function submit() {
  emit("save", {
    title: form.title,
    prepared_by: form.prepared_by,
    executive_snapshot_note: form.executive_snapshot_note,
    overall_recommendation_summary: form.overall_recommendation_summary,
    sections: { ...form.sections },
  });
}

watch(
  () => [props.open, props.report],
  ([open]) => {
    if (open) {
      resetForm();
    }
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[25] || (_cache[25] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-h-[90vh] w-[96vw] max-w-3xl overflow-y-auto rounded-[1.35rem] border border-[#d8e4f0] bg-white p-0 shadow-[0_24px_60px_rgba(15,23,42,0.2)]" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(DialogHeader), { class: "gap-y-2 text-left" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { class: "text-[1.35rem] font-extrabold text-[#0f172a]" }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" Edit Generated Report ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), { class: "text-[#64748b]" }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode(" Update the report text fields and save to regenerate the preview. Only enabled sections are listed. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("form", {
            class: "space-y-5 px-6 py-5",
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "field-label" }, "Report title", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                  class: "field-input",
                  type: "text"
                }, null, 512), [
                  [_vModelText, form.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { class: "field-label" }, "Prepared by", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.prepared_by) = $event)),
                  class: "field-input",
                  type: "text"
                }, null, 512), [
                  [_vModelText, form.prepared_by]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "field-label" }, "Executive snapshot note", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.executive_snapshot_note) = $event)),
                  class: "field-textarea",
                  rows: "4"
                }, null, 512), [
                  [_vModelText, form.executive_snapshot_note]
                ])
              ]),
              (sectionEnabled('socialMediaPerformance'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "Social Media Performance")
                    ], -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.sections.socialMediaPerformance.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.socialMediaPerformance.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.sections.socialMediaPerformance.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.socialMediaPerformance.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('aiChatbotManagement'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "AI Chatbot Management")
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.sections.aiChatbotManagement.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.aiChatbotManagement.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.sections.aiChatbotManagement.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.aiChatbotManagement.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('aiPodcastProgress'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "AI Podcast Progress")
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.sections.aiPodcastProgress.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.aiPodcastProgress.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.sections.aiPodcastProgress.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.aiPodcastProgress.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('promotionalMaterials'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "Promotional Materials")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.sections.promotionalMaterials.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.promotionalMaterials.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.sections.promotionalMaterials.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.promotionalMaterials.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('blogManagement'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "Blog Management")
                    ], -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.sections.blogManagement.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.blogManagement.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.sections.blogManagement.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.blogManagement.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('seoManagement'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "SEO Management")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Progress Summary", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.sections.seoManagement.summary) = $event)),
                        class: "field-textarea",
                        rows: "2"
                      }, null, 512), [
                        [_vModelText, form.sections.seoManagement.summary]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.sections.seoManagement.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.seoManagement.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[48] || (_cache[48] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.sections.seoManagement.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.seoManagement.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('adsManagement'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "Ads Management")
                    ], -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[50] || (_cache[50] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.sections.adsManagement.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.adsManagement.insight]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('journey'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "The Three-Month Journey")
                    ], -1)),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[52] || (_cache[52] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Key Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.sections.journey.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.journey.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[53] || (_cache[53] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Next Action / Recommendation", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.sections.journey.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.journey.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (sectionEnabled('generatedLeads'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "space-y-2 md:col-span-2 border-t border-[#f0f4fa] pt-3 mt-1" }, [
                      _createElementVNode("span", { class: "text-xs font-bold text-[#2f6fab]" }, "Generated Leads")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[55] || (_cache[55] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Key Insight", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.sections.generatedLeads.insight) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.generatedLeads.insight]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[56] || (_cache[56] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Key Learning", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.sections.generatedLeads.learning) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.generatedLeads.learning]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Business Meaning", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.sections.generatedLeads.business_meaning) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.generatedLeads.business_meaning]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[58] || (_cache[58] = _createElementVNode("label", { class: "field-label text-[10px]" }, "Next Action", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.sections.generatedLeads.recommendation) = $event)),
                        class: "field-textarea",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, form.sections.generatedLeads.recommendation]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                _cache[60] || (_cache[60] = _createElementVNode("label", { class: "field-label" }, "Overall recommendation summary", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.overall_recommendation_summary) = $event)),
                  class: "field-textarea",
                  rows: "5"
                }, null, 512), [
                  [_vModelText, form.overall_recommendation_summary]
                ])
              ])
            ]),
            (__props.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true),
            _createVNode(_unref(DialogFooter), { class: "border-t border-[#e3eaf4] px-0 pt-4" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  type: "button",
                  variant: "outline",
                  class: "rounded-[0.95rem] border-[#d7e2ef] bg-[#f6f9ff] px-4 py-2 font-bold text-[#2855a6]",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (emit('update:open', false)))
                }, {
                  default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  type: "submit",
                  class: "rounded-[0.95rem] bg-[#173b5f] px-4 py-2 font-bold text-white",
                  disabled: __props.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.loading ? "Saving..." : "Save Changes"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})